import { Directive, EventEmitter, forwardRef, Output } from '@angular/core';

import { DEFAULT_LIST_ITEM_COMPONENT } from '../../default-templates/list-item/list-item.component';
import { DEFAULT_SELECTED_ITEM_COMPONENT } from '../../default-templates/selected-item/selected-item.component';
import { DEFAULT_TRIGGER_COMPONENT } from '../../default-templates/trigger/trigger-default.component';
import { SelectController } from '../../services/select-controller.service';
import { provideOpenStrategy, StrategyRelevance } from '../../strategies/open/types';
import type { Select2Item } from '../../types';
import { ItemSelector } from '../../types';
import { MultiSelectListItemComponent } from './list-item/list-item.component';
import { MultiselectItemSelector } from './multiselect-item-selector';
import { OverlayOpenStrategy } from './overlay-open-strategy';
import { SelectedItemCounterResolverDirective } from './selected-item-counter/selected-item-counter-resolver.directive';
import type { SelectedItemCounterDirective } from './selected-item-counter/selected-item-counter.directive';
import { MultiSelectItemComponent } from './selected-item/selected-item.component';
import { MultiSelectTriggerComponent } from './trigger/trigger-default.component';
import type { MultiselectFeature } from './types';
import { MULTISELECT_FEATURE } from './types';

@Directive({
  standalone: true,
  selector: 'rt-select2[withMultiselect]',
  providers: [
    { provide: ItemSelector, useFactory: () => new MultiselectItemSelector() },
    { provide: DEFAULT_SELECTED_ITEM_COMPONENT, useValue: MultiSelectItemComponent },
    // eslint-disable-next-line @angular-eslint/no-forward-ref
    { provide: DEFAULT_TRIGGER_COMPONENT, useValue: forwardRef(() => MultiSelectTriggerComponent) },
    { provide: DEFAULT_LIST_ITEM_COMPONENT, useValue: MultiSelectListItemComponent },
    { provide: MULTISELECT_FEATURE, useExisting: MultiselectFeatureDirective },
    provideOpenStrategy(OverlayOpenStrategy, StrategyRelevance.Feature),
  ],
  hostDirectives: [SelectedItemCounterResolverDirective],
})
export class MultiselectFeatureDirective implements MultiselectFeature {
  @Output() public chipRemoved = new EventEmitter<void>();

  public selectedItemCounterDirective: SelectedItemCounterDirective<any>;

  constructor(
    public selectController: SelectController<
      { items: Select2Item[] },
      MultiselectItemSelector<Select2Item>
    >,
    private selectedItemCounterResolver: SelectedItemCounterResolverDirective,
  ) {}

  public ngAfterContentInit() {
    this.selectedItemCounterDirective = this.selectedItemCounterResolver.resolve();
  }
}
